module.exports = __webpack_public_path__ + "img/2019homepark-1.77b21ba9.jpeg";